import { Injectable } from '@angular/core';
import { OldDevices, Systems } from '../models';

import { extractVariablesFromDescriptionField, createSystem, updateSystem } from './migration.utils';

const adapter = (data: OldDevices): Systems => {
  let systems: Systems = [];
  for (const device in data) {
    if (Object.prototype.hasOwnProperty.call(data, device)) {
      const oldDevice = data[device];
      const extraVariables = extractVariablesFromDescriptionField(oldDevice?.description);
      const foundSystemIndex = systems.findIndex((system) => system.name === extraVariables.systemName);
      if (foundSystemIndex === -1) {
        systems = createSystem(systems, oldDevice, extraVariables);
      } else {
        const temp = { ... systems[foundSystemIndex] };
        systems[foundSystemIndex] = updateSystem(temp, oldDevice, extraVariables);
      }
    }
  }

  return systems;
};

@Injectable({
  providedIn: 'root',
})
export class MigrationService {

  readonly adapter = adapter;
}
